import { FieldNames } from 'Constants/FieldNames'
import { Roles } from 'Constants/Roles'

export enum KEYS {
	USERS = 'users',
	TERR_MANAGER = 'terr_manager',
	REG_MANAGER = 'reg_manager',
	CHANNEL = 'channel',
	CITY_ID = 'city_id',
	SPECIAL_OFFER_IDS = 'special_offer_ids',
	RULE_ID = 'rule_id',
	ORDER_IDS = 'order_ids',
	TERRITORIAL_BANK_ID = 'territorial_bank_id',
	CHANNEL_IDS = 'channel_ids',
	SECTOR_ID = 'sector_id',
	MERCHANT_ID = 'merchant_id',
	CATEGORY = 'categories',
	GOSB_ID = 'gosbs',
	ROLE_IDS = 'role_ids',
	MERCHANT_BRANCH_ID = 'merchant_branch_id',
	REGION_ID = 'region_id',
	SUBSTITUTIONS = 'substitutions',
	MCC_CODE_ID = 'mcc_code_id',
	PROJECT = 'project',
	INTEGRATION_CHANNELS_ID = 'integration_channels_id',
	PARTNER_FOR_FILTER = 'partner_for_filter',
	INTERFACE_ELEMENT_IDS = 'interface_element_ids',
	MCC_GROUP_ID = 'mcc_group_id',
	PARTNER_ID = 'partner_id',
	DEAL_SUBJECT_ID = 'deal_subject_id',
	OKVED_PACKAGE = 'okved_package',
	PLATFORMS = 'platforms',
	PARTNER_ACCESS_PERIODS = 'partner_access_periods',
	INTEGRATION_CODES = 'integration_codes',
	CHANNEL_CATEGORIES = 'channel_categories',
	PRODUCT_ORDER_STATUS_IDS = 'product_order_status_ids',
	PRODUCT_ORDER_STATUS = 'product_order_status',
	PRODUCT_GROUP_ID = 'product_group_id',
	DEPARTMENT_ID = 'department_id',
	ROLE_WITH_ACCESS_IDS = 'role_with_access_ids',
	ACTIVITY_CODES = 'activity_codes',
	TRANSPORT_TYPE_CODES = 'transport_type_codes',
	OBJECT_CODE_TYPES = 'object_code_types',
	OBJECT_ATTRIBUTES = 'object_attributes',
	MANAGER_ID = 'manager_id',
	PRODUCT_PROFILE = 'product_profile',
	PRODUCT = 'product',
	SBER_GEO_UNIT = 'sber_geo_unit',
	DEPARTMENTS_FOR_FILTER = 'departments_for_filter',
	TAGS_ATTRIBUTES = 'tags_attributes',
	ACT_SIGNERS = 'act_signers',
}

export const URLS = {
	[KEYS.USERS]: '/user',
	[KEYS.TERR_MANAGER]: '/user',
	[KEYS.REG_MANAGER]: '/user',
	[KEYS.CHANNEL]: '/channel',
	[KEYS.CITY_ID]: '/sber_mq/city',
	[KEYS.RULE_ID]: '/sms_rule',
	[KEYS.ORDER_IDS]: '/sber_mq/order',
	[KEYS.SPECIAL_OFFER_IDS]: '/special_offers',
	[KEYS.TERRITORIAL_BANK_ID]: '/territorial_bank',
	[KEYS.CHANNEL_IDS]: '/channel',
	[KEYS.SECTOR_ID]: '/sectors',
	[KEYS.MERCHANT_ID]: '/merchant',
	[KEYS.CATEGORY]: '/gosbs/categories',
	[KEYS.GOSB_ID]: '/gosbs',
	[KEYS.ROLE_IDS]: '/role',
	[KEYS.MERCHANT_BRANCH_ID]: '/sber_mq/merchant_branch',
	[KEYS.REGION_ID]: '/sber_mq/region',
	[KEYS.SUBSTITUTIONS]: '/users_for_substitution',
	[KEYS.MCC_CODE_ID]: '/mcc_code',
	[KEYS.PROJECT]: '/knowledge/project',
	[KEYS.INTEGRATION_CHANNELS_ID]: '/sber_mq/integration_channel',
	[KEYS.PARTNER_FOR_FILTER]: '/partner/for_filter',
	[KEYS.INTERFACE_ELEMENT_IDS]: '/interface_element',
	[KEYS.MCC_GROUP_ID]: '/mcc_group',
	[KEYS.PARTNER_ID]: '/partner',
	[KEYS.DEAL_SUBJECT_ID]: '/deal_subject',
	[KEYS.OKVED_PACKAGE]: '/okved_package',
	[KEYS.PLATFORMS]: '/ord/platforms',
	[KEYS.PARTNER_ACCESS_PERIODS]: '/exam/dictionaries',
	[KEYS.INTEGRATION_CODES]: '/sber_mq/product/integration_codes',
	[KEYS.CHANNEL_CATEGORIES]: '/channel/categories',
	[KEYS.PRODUCT_ORDER_STATUS_IDS]: '/sber_mq/status_model/sub_statuses',
	[KEYS.PRODUCT_ORDER_STATUS]: '/sber_mq/status_model/statuses',
	[KEYS.PRODUCT_GROUP_ID]: '/sber_mq/product_group',
	[KEYS.DEPARTMENT_ID]: '/department',
	[KEYS.ROLE_WITH_ACCESS_IDS]: '/filters/roles',
	[KEYS.ACTIVITY_CODES]: '/rbidos/dicts/activity_codes',
	[KEYS.TRANSPORT_TYPE_CODES]: '/rbidos/dicts/transport_type_codes',
	[KEYS.OBJECT_CODE_TYPES]: '/rbidos/dicts/object_code_types',
	[KEYS.OBJECT_ATTRIBUTES]: '/rbidos/dicts/types_of_object_attributes',
	[KEYS.MANAGER_ID]: '/filters/managers',
	[KEYS.PRODUCT_PROFILE]: '/product_profile',
	[KEYS.PRODUCT]: '/sber_mq/product',
	[KEYS.SBER_GEO_UNIT]: '/sber_geo_units',
	[KEYS.DEPARTMENTS_FOR_FILTER]: '/department/available_for_filter',
	[KEYS.TAGS_ATTRIBUTES]: '/knowledge/tag/',
	[KEYS.ACT_SIGNERS]: '/nepal/dicts/act_signers',
}

export const FIELDS = {
	[KEYS.USERS]: FieldNames.USER_ID,
	[KEYS.TERR_MANAGER]: FieldNames.TERRITORIAL_MANAGER_ID,
	[KEYS.REG_MANAGER]: FieldNames.MANAGER_ID,
	[KEYS.CHANNEL]: FieldNames.CHANNEL_ID,
	[KEYS.CITY_ID]: FieldNames.CITY_ID,
	[KEYS.SPECIAL_OFFER_IDS]: FieldNames.SPECIAL_OFFER_IDS,
	[KEYS.RULE_ID]: FieldNames.RULE_ID,
	[KEYS.TERRITORIAL_BANK_ID]: FieldNames.TERRITORIAL_BANK_ID,
	[KEYS.CHANNEL_IDS]: FieldNames.CHANNEL_IDS,
	[KEYS.SECTOR_ID]: FieldNames.SECTOR_ID,
	[KEYS.MERCHANT_ID]: FieldNames.MERCHANT_ID,
	[KEYS.CATEGORY]: FieldNames.CATEGORY,
	[KEYS.ORDER_IDS]: FieldNames.ORDER_IDS,
	[KEYS.GOSB_ID]: FieldNames.GOSB_ID,
	[KEYS.ROLE_IDS]: FieldNames.ROLE_IDS,
	[KEYS.MERCHANT_BRANCH_ID]: FieldNames.MERCHANT_BRANCH_ID,
	[KEYS.REGION_ID]: FieldNames.REGION_ID,
	[KEYS.SUBSTITUTIONS]: FieldNames.SUBSTITUTION_ID,
	[KEYS.MCC_CODE_ID]: FieldNames.MCC_CODE_ID,
	[KEYS.PROJECT]: FieldNames.PROJECT_ID,
	[KEYS.INTEGRATION_CHANNELS_ID]: FieldNames.INTEGRATION_CHANNELS_ID,
	[KEYS.PARTNER_FOR_FILTER]: FieldNames.PARTNER_ID,
	[KEYS.INTERFACE_ELEMENT_IDS]: FieldNames.INTERFACE_ELEMENT_IDS,
	[KEYS.MCC_GROUP_ID]: FieldNames.MCC_GROUP_ID,
	[KEYS.PARTNER_ID]: FieldNames.PARTNER_ID,
	[KEYS.DEAL_SUBJECT_ID]: FieldNames.DEAL_SUBJECT_ID,
	[KEYS.OKVED_PACKAGE]: FieldNames.PACKAGE_OKVED,
	[KEYS.PLATFORMS]: FieldNames.PLATFORM_IDS,
	[KEYS.PARTNER_ACCESS_PERIODS]: FieldNames.PARTNER_ACCESS_PERIODS,
	[KEYS.INTEGRATION_CODES]: FieldNames.INTEGRATION_CODE,
	[KEYS.CHANNEL_CATEGORIES]: FieldNames.CATEGORY,
	[KEYS.PRODUCT_ORDER_STATUS_IDS]: FieldNames.PRODUCT_ORDER_STATUS_IDS,
	[KEYS.PRODUCT_ORDER_STATUS]: FieldNames.PRODUCT_STATUS_NAME,
	[KEYS.PRODUCT_GROUP_ID]: FieldNames.PRODUCT_GROUP_ID,
	[KEYS.DEPARTMENT_ID]: FieldNames.DEPARTMENT_ID,
	[KEYS.ROLE_WITH_ACCESS_IDS]: FieldNames.ROLE_IDS,
	[KEYS.ACTIVITY_CODES]: FieldNames.ACTIVITY_CODE_ID,
	[KEYS.TRANSPORT_TYPE_CODES]: FieldNames.TRANSPORT_TYPE_CODE_ID,
	[KEYS.OBJECT_CODE_TYPES]: FieldNames.OBJECT_CODE_TYPE_ID,
	[KEYS.OBJECT_ATTRIBUTES]: FieldNames.TYPES_OF_OBJECT_ATTRIBUTE_ID,
	[KEYS.MANAGER_ID]: FieldNames.MANAGER_ID,
	[KEYS.PRODUCT_PROFILE]: FieldNames.PRODUCT_PROFILES_IDS,
	[KEYS.PRODUCT]: FieldNames.PRODUCT_IDS,
	[KEYS.SBER_GEO_UNIT]: FieldNames.SBER_GEO_UNIT_CODE_NSI,
	[KEYS.DEPARTMENTS_FOR_FILTER]: FieldNames.DEPARTMENT_ID,
	[KEYS.TAGS_ATTRIBUTES]: FieldNames.TAGS_ATTRIBUTES,
	[KEYS.ACT_SIGNERS]: FieldNames.SIGNER_NAME,
}

export const PARAMS_DATA = {
	[KEYS.TERR_MANAGER]: { role_slug: Roles.TERMEN },
	[KEYS.REG_MANAGER]: { role_slug: Roles.REGMEN },
}

export const FILL_FIELDS = {
	[KEYS.ORDER_IDS]: 'number',
}
